export const UPDATE_ROUTE = "UPDATE_ROUTE";
export const ADD_ROUTE = "ADD_ROUTE";
export const DELETE_ROUTE ="DELETE_ROUTE";


export interface IRouteAll {
        name?: string,
        link?: string
}

interface IRouteAction {
    type: typeof  UPDATE_ROUTE | typeof ADD_ROUTE | typeof DELETE_ROUTE,
    data: IRouteAll
}

export type RouteActionTypes = IRouteAction;